 <template>
  <div>
    <div class="content-box">
      <div class="row">
        <div class="col-lg-12">
          <div class="element-wrapper">
            <div class="element-box">
              <router-link
                class="btn btn-sm btn-outline-info"
                :to="{ name: 'wms-tarea-usuario' }"
              >
                <i class="fas fa-angle-double-left"></i>
                Regresar
              </router-link>
              <h5 class="form-header">
                <h5 v-if="!current.id">
                  Asignar Nueva Tarea Usuario &nbsp;
                  <i class="fas fa-plus fa-lg text-success"></i>
                </h5>
                <h5 v-if="current.id">
                  Asignar Usuario Tarea
                  <span
                    class="badge"
                    v-bind:class="{
                      'badge-success': current.estatus == true,
                      'badge-danger': current.estatus == false,
                    }"
                    ><div v-if="current.estatus == true">ACTIVO</div>
                    <div v-if="current.estatus == false">INACTIVO</div></span
                  >
                  &nbsp;&nbsp;
                  <i
                    v-bind:class="{
                      'text-success os-icon os-icon-user-check':
                        current.estatus == true,
                      'text-danger os-icon os-icon-user-x':
                        current.estatus == false,
                    }"
                    style="font-size: 28px"
                  ></i>
                  &nbsp;<span
                    v-bind:class="{
                      'text-success': current.estatus == true,
                      'text-danger': current.estatus == false,
                    }"
                    >{{ current.pickeador_obj.name }}</span
                  >
                </h5>
                &nbsp;
                <div class="element-actions">
                  <div class="btn-group">
                    <button
                      :disabled="!current.id"
                      aria-expanded="false"
                      aria-haspopup="true"
                      class="btn btn-secondary dropdown-toggle"
                      data-toggle="dropdown"
                      type="button"
                    >
                      <i class="fa fa-cogs"></i>
                      Acciones
                    </button>
                    <div class="dropdown-menu dropdown-menu-right">
                      <button
                        @click="darDeBaja()"
                        class="dropdown-item"
                        type="button"
                        :disabled="current.estatus == false"
                        data-toggle="modal"
                        data-target="#modalAsignarUsuario"
                      >
                        <i class="far fa-file-excel fa-bounce"></i>
                        &nbsp; Dar de baja
                      </button>
                      <div class="dropdown-divider"></div>
                    </div>
                  </div>
                </div>
              </h5>
              <div class="row">
                <div class="col-3">
                  <label
                    v-bind:class="{
                      'text-danger': current.errors && current.errors.tienda,
                    }"
                    >Tienda origen</label
                  >
                  <select
                    :disabled="current.estatus == false"
                    class="form-control"
                    v-model="current.tienda_origen"
                  >
                    <option
                      v-for="(tienda, key) in tiendas"
                      :value="tienda.codigo"
                      :key="key"
                    >
                      {{ tienda.codigo }} - {{ tienda.nombre }}
                    </option>
                  </select>
                  <small
                    v-if="current.errors && current.errors.tienda"
                    class="form-text text-danger"
                    >{{ current.errors.tienda[0] }}</small
                  >
                  <br />
                </div>
                <div class="col-3">
                  <label
                    v-bind:class="{
                      'text-danger': current.errors && current.errors.tienda,
                    }"
                    >Tienda destino</label
                  >
                  <select
                    :disabled="current.estatus == false"
                    class="form-control"
                    v-model="current.tienda_destino"
                  >
                    <option
                      v-for="(tienda, key) in tiendas"
                      :value="tienda.codigo"
                      :key="key"
                    >
                      {{ tienda.codigo }} - {{ tienda.nombre }}
                    </option>
                  </select>
                  <small
                    v-if="current.errors && current.errors.tienda"
                    class="form-text text-danger"
                    >{{ current.errors.tienda[0] }}</small
                  >
                  <br />
                </div>
                <div class="col-3">
                  <label>Fecha inicio</label>
                  <input
                    :disabled="current.id"
                    type="date"
                    class="form-control"
                    v-model="current.fecha_inicio"
                  />
                  <small
                    class="text-danger"
                    v-if="current.errors && current.errors.fecha_inicio"
                    >{{ current.errors.fecha_inicio }}</small
                  >
                </div>
                <div class="col-3">
                  <label>Fecha fin</label>
                  <input
                    :disabled="current.estatus == false"
                    type="date"
                    class="form-control"
                    v-model="current.fecha_fin"
                  />
                  <small
                    class="text-danger"
                    v-if="current.errors && current.errors.fecha_fin"
                    >{{ current.errors.fecha_fin }}</small
                  >
                  <br />
                </div>
                <div class="col-4">
                  <div class="form-group">
                    <label
                      v-bind:class="{
                        'text-danger':
                          current.errors && current.errors.tipo_tarea,
                      }"
                      >Tipo Tarea</label
                    >
                    <select
                      :disabled="current.estatus == false"
                      class="form-control"
                      autofocus="autofocus"
                      v-model="current.tarea_tipo"
                    >
                      <option
                        v-for="(c, key) in tarea_tipo"
                        :value="c.id"
                        :key="key"
                      >
                        {{ c.nombre }} -
                        <div v-if="c.estatus == true">ACTIVO</div>
                        <div v-if="c.estatus == false">INACTIVO</div>
                      </option>
                    </select>
                    <small
                      v-if="current.errors && current.errors.tipo_tarea"
                      class="form-text text-danger"
                      >{{ current.errors.tipo_tarea[0] }}</small
                    >
                  </div>
                </div>
                <div class="col-4">
                  <UsuariosSelectComponent
                    titulo="Pickeador"
                    :current="current"
                    :disabled="current.estatus == false"
                  />
                  <small
                    class="text-danger"
                    v-if="current.errors && current.errors.nombre"
                    >{{ current.errors.nombre }}</small
                  >
                  <br />
                </div>
                <div class="col-4">
                  <CategoriaSelectComponent
                    :disabled="current.estatus == false"
                    :current="current"
                  />
                </div>
                <div class="col-6">
                  <SubCategoriaSelectComponent
                    :disabled="current.estatus == false"
                    :current="current"
                  />
                </div>
                <div class="col-6">
                  <ProveedoresSelectComponent
                    :disabled="current.estatus == false"
                    :current="current"
                  />
                </div>
              </div>
              <div class="form-buttons-w">
                <button
                  :disabled="current.estatus == false"
                  class="btn btn-md btn-success"
                  type="button"
                  @click="guardar()"
                >
                  <i class="fas fa-save"></i> Guardar
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Notifications from "@/notifications/notifications";
import DynamicService from "@/services/commons/DynamicService";
import UsuariosSelectComponent from "@/components/commons/UsuariosSelectComponent";
import CategoriaSelectComponent from "@/components/commons/CategoriaSelectComponent ";
import TiendaSelectComponent from "@/components/commons/TiendaSelectComponent";
import SubCategoriaSelectComponent from "@/components/commons/SubCategoriaSelectComponent ";
import ProveedoresSelectComponent from "@/components/commons/ProveedoresSelectComponent";

export default {
  components: {
    TiendaSelectComponent,
    UsuariosSelectComponent,
    SubCategoriaSelectComponent,
    CategoriaSelectComponent,
    ProveedoresSelectComponent,
  },
  data() {
    return {
      estatus: false,
      tarea_tipo: "",
      current: {
        tipo_tarea: "",
        estado: "A",
        estatus: true,
        tienda: "",
        fecha: "",
        errors: [],
        usuario: "",
        fecha_inicio: "",
        fecha_fin: "",
        tipos_liq: "",
        producto: "",
      },
      detalle: {},
      tipos_liq: [],
      tiendas: [],
      currentDetalle: {},
      tiendas: "",
    };
  },
  computed: {},
  mounted() {
    let self = this;
    self.refreshTienda();
    self.refreshTareaTipo();
    if (this.$route.params.id) {
      self.refreshCurrent();
    }
  },
  methods: {
    darDeBaja() {
      let self = this;
      Notifications.alert.confirm(
        "Dar de baja a la asignación",
        "¿Esta seguro?",
        "",
        function () {
          DynamicService.postAction(
            "wms",
            "asignar-tarea-usuario",
            self.current.id,
            "dar_de_baja"
          )
            .then((response) => {
              Notifications.alert.success(
                "Dar de Baja",
                "Realizado Exitosamente"
              );
              self.refreshCurrent();
            })
            .catch((error) => {
              Notifications.alert.error(
                "Dar de baja",
                error.response.data.detail
              );
            });
        }
      );
    },
    refreshTienda() {
      let self = this;
      DynamicService.fetch("cat", "tiendas", {
        quitar_paginacion: true,
      }).then((response) => {
        self.tiendas = response.data;
      });
    },
    refreshTareaTipo() {
      let self = this;
      DynamicService.fetch("wms", "tarea-tipo", {
        quitar_paginacion: true,
      }).then((response) => {
        self.tarea_tipo = response.data;
      });
    },
    guardar() {
      let self = this;
      if (self.current.categoria) {
        self.current.categoria = self.current.categoria.codigo;
      }
      if (self.current.subcategoria) {
        self.current.sub_categoria = self.current.subcategoria.codigo;
      }
      if (self.current.usuario) {
        self.current.pickeador = self.current.usuario.id;
      }
      if (self.current.proveedor) {
        self.current.proveedor = self.current.proveedor.codigo;
      }
      console.log(self.current);
      if (self.current.fecha_fin) {
        self.current.fecha_fin = moment(
          self.current.fecha_fin,
          "YYYY-MM-DD"
        ).format("YYYY-MM-DDTHH:mm:ss.SSS");
      }

      if (self.current.fecha_inicio) {
        self.current.fecha_fin = moment(
          self.current.fecha_fin,
          "YYYY-MM-DD"
        ).format("YYYY-MM-DDTHH:mm:ss.SSS");
      }
      DynamicService.save("wms", "asignar-tarea-usuario", self.current)
        .then((response) => {
          Notifications.alert.success(
            "Agregar nueva asignación de usuario y tarea",
            "Agregado existosamente"
          );
          self.$router.push({
            name: "wms-tarea-usuario-editar",
            params: { id: response.data.id },
          });
          self.refreshCurrent();
        })
        .catch((errors) => {
          self.current.errors = errors.response.data;
        });
    },
    refreshCurrent() {
      let self = this;
      DynamicService.getById(
        "wms",
        "asignar-tarea-usuario",
        this.$route.params.id
      ).then((response) => {
        self.current = response.data;
        self.current.usuario = self.current.pickeador_obj;
        self.current.subcategoria = self.current.sub_categoria;
        self.current.fecha_inicio = moment(
          self.current.fecha_inicio,
          "YYYY-MM-DDTHH:mm:ss.SSS"
        ).format("YYYY-MM-DD");
        self.current.fecha_fin = moment(
          self.current.fecha_fin,
          "YYYY-MM-DDTHH:mm:ss.SSS"
        ).format("YYYY-MM-DD");
        self.current.estado = "B";
        self.estatus = true;
        console.log(self.current);
      });
    },
  },
};
</script>
